import cn from '../../utils/classNames.js';

export default function Loader({ fullScreen = false, label = 'Loading…' }) {
  return (
    <div
      className={cn(
        'flex items-center justify-center gap-2 text-sm text-slate-500',
        fullScreen ? 'min-h-screen' : 'p-6'
      )}
    >
      <span className="h-3 w-3 animate-pulse rounded-full bg-brand-500" />
      <span>{label}</span>
    </div>
  );
}
